<template>
  <div class="recipient-list-select rate-select">
    <v-select
      class="custom gift-select rate-select"
      :class="{
        'invalid-input': showError
      }"
      :placeholder="loading ? 'Loading...' : placeholder"
      label="text"
      :options="loading ? [] : shippingRates"
      :value="selectedOption"
      @input="handleChange"
      :clearable="false"
      :searchable="false"
      :closeOnSelect="true"
      :multiple="false"
      :disabled="disabled"
    >
      <template #open-indicator="{ attributes }">
        <span v-bind="attributes"
          ><svg
            width="9"
            height="5"
            viewBox="0 0 9 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.5 5C4.38766 5 4.27531 4.95646 4.18974 4.86983L0.128691 0.758491C-0.0428968 0.584779 -0.0428968 0.303996 0.128691 0.130284C0.300278 -0.043428 0.577626 -0.043428 0.749214 0.130284L4.5 3.92752L8.25079 0.130284C8.42237 -0.043428 8.69972 -0.043428 8.87131 0.130284C9.0429 0.303996 9.0429 0.584779 8.87131 0.758491L4.81026 4.86983C4.72469 4.95646 4.61234 5 4.5 5Z"
              fill="#25282A"
            />
          </svg>
        </span>
      </template>

      <template #option="{ id, text }">
        <div>
          {{ text }}
        </div>
      </template>
    </v-select>
    <div class="validation-error" v-if="showError">
      <small>Required</small>
    </div>
  </div>
</template>

<script>
import { trimText } from '@/helpers'
import Util from '../../mixins/Util'

export default {
  name: 'ShippingOptionsDropdown',
  mixins: [Util],
  props: {
    shippingRates: {
      type: Array,
      default: () => []
    },
    selectedOption: {
      type: Object,
      default: () => {}
    },

    placeholder: {
      type: String,
      default: 'Select a shipping option*'
    },

    loading: {
      type: Boolean,
      default: false
    },
    showError: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    trimText
  }),

  methods: {
    handleChange(value) {
      if (!value) return
      this.$emit('handleSelection', value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.recipient-list-select {
  flex-basis: 45%;
  display: flex;
  flex-direction: column;
  padding: 0;

  &.isSendGift {
    width: 35%;
    padding: 20px 32px;
  }

  .glass {
    border-bottom: 1px solid;
    height: 48px;
  }

  .checkbox-container {
    p {
      color: #222222;
      font-size: 0.75rem;
      margin-left: 32px;
      margin-top: 3px;
    }
  }
}

@media (max-width: 568px) {
  .recipient-list-select {
    &.isSendGift {
      width: 100%;
    }
  }
}
</style>
